import React, { Suspense, useEffect, useState, useRef } from "react";
import PropTypes from "prop-types";

// eslint-disable-next-line react/display-name
const LazyLoad = React.forwardRef(
  ({ component = null, folder = "", ...rest }, ref) => {
    const [Component, setComponent] = useState(null);
    const mountedRef = useRef(true);

    const importComponent = (component) =>
      React.lazy(() => {
        // console.log(`./${component}.js`);
        return import(`./${component}.js`).catch(() =>
          console.log("Error in importing")
        );
      });

    useEffect(() => {
      async function loadComponent() {
        if (component && mountedRef) {
          const C = importComponent(component);
          new Promise((resolve) => {
            resolve(C);
          }).then(setComponent);
        }
      }

      loadComponent();

      return () => (mountedRef.current = false);
    }, [component]);

    return (
      <Suspense fallback={<>...</>}>
        {Component && <Component ref={ref} {...rest} />}
      </Suspense>
    );
  }
);

LazyLoad.propTypes = {
  component: PropTypes.string,
  folder: PropTypes.string,
};

export default LazyLoad;
